import { FC } from 'react';
import BookCardItem from '../book-card-item/BookCardItem';
import styles from './BookCardsList.module.scss';
import { IBooksPageData } from '@/interfaces/booksPage.interface';

interface IBookCardsListProps {
  books: IBooksPageData[];
  extraClassName?: string;
}

const BookCardsList: FC<IBookCardsListProps> = ({ books, extraClassName }) => {
  const getListClassNames = () => (extraClassName ? `${styles.bookCardsList} ${styles[`${extraClassName}`]}` : `${styles.bookCardsList}`);

  return (
    <div className={getListClassNames()}>
      {books && books.length ? (
        books.map((book: IBooksPageData) => {
          // const createdAt = !!createdDate ? book.created_at : "";
          return (
            <BookCardItem
              key={book.id}
              createdAt={book.created_at}
              id={book.id}
              rating={book.rating}
              author={book.author}
              hideLitresData={book.hide_litres_data}
              retelling={book.retaling}
              draft={book.draft}
              title={book.book.title}
              type={book.type}
              description={book.book.description}
              genres={book.genres}
              allow_full_free={book.book.allow_full_free}
              external_id={book.book.external_id}
            />
          );
        })
      ) : (
        <div>Книги не найдены</div>
      )}
    </div>
  );
};

export default BookCardsList;
